// plugins/countryCodes.js

import Vue from "vue";
import { getCountries } from "libphonenumber-js";

// Assign countryCodes to Vue's prototype
Vue.prototype.$getAllCountryCodes = () => {
  return getCountries();
};
